RivalIQ.module('overrides.backbone', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    // cache, we will call this later
    const View = Backbone.View;

    // a list of events that we categorically do not want to debounce
    const eventNonDebounceList = [
        'input',
        'keypress',
        'mouseleave',
        'mouseenter'
    ];

    Backbone.View = function (options) {
        const me = this;
        const opts = options || {};
        const debounceTime = opts.debounceTime || 500;

        // if this class does not support the normalization of UI keys, then default to return
        // whatever it is that is passed into the function (this prevents breakage downstream)
        if (!_.isFunction(me.normalizeUIKeys)) {
            me.normalizeUIKeys = _.identity;
        }

        // grab effective events by calling a function, using a hash, or defaulting to empty
        // NOTE: it is very important not to override the base events, so we extend an object with what we find
        // if we didn't do this then inherited events would stomp on each other, and first to wire would "win"
        const events = _.extend({}, _.result(me, 'events'));
        // grab effective events not to debounce by calling a function, using a hash, or defaulting to empty
        const eventsNotToDebounce = me.normalizeUIKeys(_.result(me, 'eventsNotToDebounce') || {});

        // iterate over each event handler
        _.each(events, function (handler, selector) {
            // if handler is a function use it, otherwise assume property on me
            const fn = (_.isFunction(handler)) ? handler : me[handler];

            if (_.isUndefined(fn)) {
                RivalIQ.logger.warn(`${handler} not defined`);
                return;
            }

            // there are certain classifications of events that we do not want to debounce
            const isNonDebounceEvent = _.some(eventNonDebounceList, function (event) {
                return Boolean(selector.match(new RegExp(`^${event}`, 'i')));
            });

            // only if this event is not non-debounce, should we debounce
            if (!isNonDebounceEvent) {
                // TODO since this debouncing does not preventDefault or
                // stopPropagation events that are debounced can still affect
                // the state of the page

                // NOTE: overwrite/copy selector to be a debounced version of the handler
                events[selector] = _.debounce(fn, debounceTime, {
                    leading: true
                });
            }
        });

        // overwrite events on this object with our new one (conveniently debounced)
        me.events = _.extend(events, eventsNotToDebounce);

        // make sure to call the original
        View.call(me, options);
    };

    // make sure things (like inheritance) still work how we expect down stream
    _.extend(Backbone.View, View);
    _.extend(Backbone.View.prototype, View.prototype);

});
